import { Link } from 'react-router-dom';
import { Card } from '@/components/ui/card';
import { Newspaper } from 'lucide-react';

const POSTS = [
  { slug: 'demarrer-comme-jobeur', title: 'Démarrer comme jobeur : 10 conseils qui marchent', excerpt: "Comment créer un profil convaincant, fixer ses tarifs, obtenir ses premiers clients et construire sa réputation sur Job Kongo.", date: '2025-01-15' },
  { slug: 'paiement-securise-mobile-money', title: 'Pourquoi payer via la plateforme ?', excerpt: "Comprendre le séquestre, l'assurance, et pourquoi ne jamais payer en dehors. Toutes les protections pour clients et jobeurs.", date: '2025-01-10' },
  { slug: 'jobs-urgents-kinshasa', title: 'Jobs urgents à Kinshasa : comment répondre vite', excerpt: "Astuces pour gérer les demandes sous 24h, optimiser son rayon de déplacement et maximiser ses revenus.", date: '2025-01-05' },
];

export default function BlogPage() {
  return (
    <div className="max-w-5xl mx-auto px-4 md:px-6 py-10">
      <div className="text-center">
        <Newspaper size={44} className="mx-auto text-[#1677F2]" />
        <h1 className="text-3xl md:text-4xl font-bold mt-2">Blog & conseils</h1>
        <p className="text-slate-600 mt-2">Guides pratiques pour jobeurs et clients.</p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-8">
        {POSTS.map((p) => (
          <Link key={p.slug} to="#">
            <Card className="p-5 h-full hover:shadow-md hover:border-[#C7E2FF]">
              <p className="text-xs text-slate-500">{p.date}</p>
              <h3 className="font-semibold mt-1 text-[#0B1220]">{p.title}</h3>
              <p className="text-sm text-slate-600 mt-2 line-clamp-3">{p.excerpt}</p>
              <p className="text-xs text-[#1677F2] mt-3 font-medium">Lire l&apos;article →</p>
            </Card>
          </Link>
        ))}
      </div>
    </div>
  );
}
